const graph = {
  "queryState": {
    "layerCatalogLoadFailed": "レイヤー一覧を読み込めませんでした",
    "savedSectionListLoadFailed": "保存済みデータを読み込めませんでした",
    "exportListLoadFailed": "エクスポートファイル一覧を読み込めませんでした",
    "shootingDateListLoadFailed": "撮影日一覧を読み込めませんでした",
  },
  "checkCrossSection": "断面確認",
  "checkLongitudeSection": "縦断面確認",
  "height": "高度",
  "distance": "距離",
  "line": "線形",
  "alignment": "線形",
  "stratum": "地層",
  "designHeight": "設計図",
  "check": "確認",
  "longitudeSection": "縦断面",
  "specificSection": "特定",
  "crossSection": "横断面",
  "crossSectionList": "横断面リスト",
  "crossSectionGraph": "横断面グラフ",
  "perpendicularInterval": "横断間隔",
  "pointInterval": "点間隔",
  "pointSetting": "地点設定",
  "detailSetting": "詳細設定",
  "startPoint": "開始点",
  "endPoint": "終点",
  "section": "区間",
  "sectionStartPoint": "始点",
  "sectionEndPoint": "終点",
  "original": "原本表示",
  "detail": "詳細表示",
  "startPointError": "開始測点は基本値より小さくなれません。",
  "enterBranch": "地点を入力してください。",
  "validate": {
    "dxfSaveFileDownloadError": "ファイルダウンロード中にエラーが発生しました。もう一度お試しください。",
    "dxfSaveFileGenerateNotice": "ファイル生成がリクエストされました。通常10分以内に完了します。しばらく後にご確認ください。",
    "dxfSaveFileGenerateError": "ファイル生成に失敗しました。しばらく後にもう一度お試しください。",
    "noSavedData": "保存されたデータがありません。",
    "failDeleteData": "データの削除に失敗しました。もう一度お試しください。",
    "savePerpendicular": "横断面が保存されました。",
    "deletePerpendicular": "横断面が削除されました。",
    "existingCrossSection": "既に保存された横断面があります。削除後にもう一度お試しください。",
    "leftRightSpacing": "点間隔より左右間隔が大きくなければなりません。",
    "pointIntervalMin": "点間隔は{{min}}m以上でなければなりません。",
    "endPointInfo": "終点を入力しないか、終点が線形の長さより長い場合は全体断面を見ることができます。",
    "lngStartPoint": "縦断面の開始測点はTEXTファイルにのみ反映されます。",
    "startStepError": "始点は基本値より小さくなれません。",
    "endStepError": "終点は始点より小さくなれません。",
    "sameStepError": "始点と終点は同じにできません。",
    "maxStratumFilesSelected": "ファイルは最大3つまで選択できます。",
    "maxStep": "間隔は100以下でなければなりません。",
    "increment": "間隔は5の倍数でなければなりません。",
    "equal": "点間隔は横断間隔より同じかそれ以下でなければなりません。",
    "setPoint": "開始点と終点を設定してください",
    "pointAdditionError": "追加地点は開始測点より小さくなれません。",
    "pointAdded": "特定横断面が追加されました。",
    "pointAdditionFailed": "特定横断面の追加に失敗しました。しばらく後にもう一度お試しください。",
    "pointAdditionTargetFailed": "既にその距離に横断面があります。入力した距離を確認してください。",
    "distanceExceedsSegmentLength": "入力した距離が線分の長さを超えました。",
    "crossSectionDeletionFailed": "横断面の削除に失敗しました。しばらく後にもう一度お試しください。"
  },
  "perpendicularList": "横断面リスト",
  "selectPerpendicular": "横断面を選択してください",
  "perpendicularDeleted": "横断面が削除されました。",
  "deleteSavedTitle": "保存された横断面の削除",
  "deleteSavedSectionMessage": "{{name}} 区間を削除しますか？",
  "deleteSavedStationMessage": "{{name}} 測点を削除しますか？",
  "exportSection": "エクスポート",
  "enterDistance": "距離を入力してください。",
  "enterDistanceInRange": "範囲内で入力してください。",
  "perpendicularDataNotFound": "該当距離の横断面データが見つかりません。",
  "specialPerpendicularAdded": "特別横断面が追加されました。",
  "perpendicularAlreadyExists": "既に同じ位置に横断面が存在します。",
  "specialPerpendicularAddFailed": "特別横断面の追加に失敗しました。",
  "perpendicularGraph": "横断面グラフ",
  "addSpecialPerpendicular": "特別横断面追加",
  "noSavedData": "保存されたデータがありません。",
  "loading": "読み込み中です",
  "delete": "削除",
  "cancel": "キャンセル",
  "edit": "編集",
  "confirm": "確認",
  "perpendicularSelectionTree": "横断面選択ツリー",
  "loadingInProgress": "読み込み中...",
  "createFile": "ファイルを作成してください。",
  "exportPerpendicularData": "横断面データエクスポート",
  "invalidFileFormat": "有効でないファイル形式です。",
  "fileReadFailed": "ファイルの読み込みに失敗しました。",
  "noSectionSelected": "選択されたセクションがありません。",
  "selectFileToExport": "エクスポートするファイルを選択してください。",
  "noExportableFiles": "エクスポートできるファイルがありません。",
  "csvDownloaded": "CSVファイルがダウンロードされました。",
  "csvDownloadFailed": "CSVダウンロードに失敗しました。",
  "dxfDownloaded": "DXFファイルがダウンロードされました。",
  "dxfDownloadFailed": "DXFダウンロードに失敗しました。",
  "earthworkTableFeatureComingSoon": "土工集計表ダウンロード機能は準備中です。",
  "selectFileToDelete": "削除するファイルを選択してください。",
  "fileDeleted": "ファイルが削除されました。",
  "fileNotFound": "ファイルが見つかりません。",
  "fileDeletionFailed": "ファイルの削除に失敗しました。",
  "selectFileToRename": "名前を変更するファイルを選択してください。",
  "noFileNameChanged": "変更されたファイル名がありません。",
  "fileRenamed": "ファイル名が変更されました。",
  "duplicateFileName": "既に同じファイル名が存在します。",
  "fileRenameFailed": "ファイル名の変更に失敗しました。",
  "fileNameSlashNotAllowed": "ファイル名に / は含めることができません。",
  "fileInfoNotFound": "ファイル情報が見つかりません。",
  "fileUpdateStarted": "ファイルの更新が開始されました。",
  "perpendicularDataNotFoundForUpdate": "横断面データが見つかりません。",
  "fileUpdateFailed": "ファイルの更新に失敗しました。",
  "fileName": "ファイル名",
  "includedFiles": "含まれるファイル",
  "updateDate": "更新日",
  "update": "更新",
  "done": "完了",
  "creating": "作成中",
  "rename": "名前修正",
  "download": "ダウンロード",
  "txtDownloadHelp": "RP、BIMNODEプログラムで横断を描けます。",
  "earthworkTable": "土工集計表",
  "earthworkTableRequirement": "土工集計表は地盤高と計画高が両方必要です",
  "earthworkTableNoData": "集計表データがありません。",
  "earthworkTableDownloaded": "土工集計表がダウンロードされました。",
  "earthworkTableDownloadFailed": "土工集計表のダウンロードに失敗しました。",
  "earthworkStationQuantity": "土工横断数量",
  "earthworkStationQuantityRequirement": "土工横断数量は地盤高と計画高が両方必要です",
  "earthworkStationQuantityNoData": "ステーション別盛土/切土データがありません。",
  "earthworkStationQuantityDownloaded": "土工横断数量がダウンロードされました。",
  "earthworkStationQuantityDownloadFailed": "土工横断数量のダウンロードに失敗しました。",
  "select": "選択",
  "itemsSelected": "個選択済み",
  "multipleSelectable": "複数選択可能",
  "singleSelectable": "1つのみ選択可能",
  "selectStandardTimeSeries": "基準時系列選択",
  "standard": "基準",
  "elevationProfile": "高度プロファイル",
  "partialMode": "部分モード",
  "resetView": "ビューリセット",
  "crossSectionElevationProfile": "横断面高度プロファイル",
  "crossSectionNumber": "番横断面",
  "station": "測点",
  "quantityTable": "数量表",
  "quantityTableTooltip": "設計図に計画高と原地盤高が両方必要です\n数量表を確認できます。",
  "crossSectionQuantityTable": "横断数量表",
  "baseDate": "基準",
  "excelDownload": "Excelダウンロード",
  "noQuantityData": "該当位置に計画高または原地盤高がないため数量表を計算できません。",
  "planned": "計画",
  "progressed": "進行",
  "currentHeight": "現況高",
  "fill": "盛土",
  "cut": "切土",
  "fillSubgrade": "路床",
  "fillRoadbed": "路体",
  "fillUncompacted": "未締固め",
  "fillRockFill": "岩盛土",
  "cutSoilCut": "土砂",
  "cutRipping": "リッパー",
  "cutBlasting": "発破",
  "earthworkSection": "区間",
  "earthworkFillGroup": "盛土",
  "earthworkCutGroup": "切土",
  "earthworkSubtotal": "小計",
  "earthworkColType": "区分",
  "earthworkColMaterial": "材料区分",
  "earthworkColPlannedQty": "計画数量",
  "earthworkColRemainingQty": "残余土工量",
  "earthworkColDailyTotal": "日別累計",
  "earthworkKeyDesignHeight": "計画高",
  "earthworkKeyGroundHeight": "地盤高",
  "timeSeries": "現況",
  "maxFourSelectable": "*最大4個選択可能",
  "complete": "完了",
  "layer": "レイヤー",
  "planDropdown": "計画",
  "stratumDropdown": "地層",
  "legendGround": "原地盤高",
  "legendDesign": "計画高",
  "stratumMaxThree": "地層（最大3個選択可能）",
  "groundMaxOne": "原地盤高（1個選択可能）",
  "designMaxOne": "計画高（1個選択可能）",
  "noAvailableLayers": "使用可能なレイヤーがありません",
  "earthworkSummaryTable": "全体土工集計表",
  "downloadOverallSummaryTable": "全体集計表ダウンロード",
  "summaryTableTooltip": "横断面ファイルを作成すると全体集計表を確認できます。"
} as const;

export default graph;
